//#region Libraries
import styled from "styled-components";
import { HEIGHT_CELL_BODY, QUARTER_HEIGHT_CELL_BODY, WIDTH_HOUR_CONTENT } from "./utils/constants";
//#endregion

export const FieldIconWrapper = styled.div`
    display: grid;
    place-items: center;
    & svg {
        width: 18px;
        height: 18px;
    }
`;
export const CursorTime = styled.div`
    border-top: 3px dashed var(--purple-2);
    position: absolute;
    left: calc(${WIDTH_HOUR_CONTENT} - 4px);
    z-index: 20;
    pointer-events: none;
    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-70%);
        border-radius: 50%;
        z-index: 2;
        width: 10px;
        height: 10px;
        background-color: var(--purple-2);
    }
`;
export const EmptyActivityCard = styled.div`
    position: relative;
    min-width: 148px;
    height: calc(${QUARTER_HEIGHT_CELL_BODY}px * ${({ heightRatio = 4 }) => heightRatio});
    margin: 1px;
    &.gray {
        background-color: var(--light-5);
    }
    &.light {
        background-color: var(--light-1);
    }
    &.clickeable {
        cursor: pointer;
        transition: 0.35s;
        &:hover {
            filter: brightness(95%);
        }
    }
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        border-top: 2px dashed var(--light-3);
    }
`;
export const InactiveActivity = styled.div`
    background-color: var(--light-blue-1);
    min-width: 148px;
    height: calc(${QUARTER_HEIGHT_CELL_BODY}px * ${({ heightRatio = 4 }) => heightRatio});
    margin: 0;
    position: relative;
    &::after {
        content: "";
        width: 100%;
        position: absolute;
        bottom: -3px;
        height: 10px;
        background-color: var(--light-blue-1);
    }
`;
export const Container = styled.section`
    width: 100%;
    height: 600px;
    overflow-x: scroll;
    position: relative;
    overflow-y: scroll;
    &.no-scroll {
        overflow-y: hidden;
    }
    &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }
    @media (max-width: 800px) {
        &::-webkit-scrollbar {
            height: 6px;
            width: 6px;
        }
    }
`;
export const HourContent = styled.h4`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    /* height: ${HEIGHT_CELL_BODY}px; */
    width: ${WIDTH_HOUR_CONTENT};
    margin: 0;
    font-size: 12px;
`;
export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    & > thead, & > tbody {
        & > tr > *:first-child {
            background-color: var(--light-5);
            color: var(--dark-4);
            width: ${WIDTH_HOUR_CONTENT};
        }
    }
    & > thead {
        position: sticky;
        z-index: 30;
        top: 0;
        background-color: var(--light-blue-2);
    }
    & > thead th {
        & .main-content {
            background-color: var(--light-5);
        }
        &:nth-child(2n) .main-content {
            background-color: var(--light-1);
        }
        & .main-content.inactive {
            background-color: var(--light-blue-1);
            * {
                color: var(--purple-4);
            }
        }
    }
    & > tbody td {
        &:first-child {
            height: ${HEIGHT_CELL_BODY/4}px;
        }
        & .empty-activity:not(.light):not(.gray) {
            background-color: var(--light-5);
        }
        &:nth-child(2n) .empty-activity:not(.light):not(.gray) {
            background-color: var(--light-1);
        }
    }
    & th, td {
        padding: 0;
    }
`;